var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-feed-container"},_vm._l((_vm.feedItems),function(item,index){return _c(item.component,_vm._b({key:index,tag:"component"},'component',item.props || {},false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }